let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("6jw5Q"), load("kHq0J")]).then(() => parcelRequire('d0wlc'));